import React from 'react';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const spreads = [
    { name: 'Yes or No Tarot', slug: 'yes-or-no' },
    { name: 'Three-Card Spread', slug: 'three-card-spread' },
    { name: 'Celtic Cross', slug: 'celtic-cross' },
    { name: 'One-Card Draw', slug: 'one-card-draw' },
    { name: 'Relationship Spread', slug: 'relationship-spread' },
    { name: 'Career Path Spread', slug: 'career-path-spread' },
    { name: 'Decision Making Spread', slug: 'decision-making-spread' },
    { name: 'Year Ahead Spread', slug: 'year-ahead-spread' },
  ];

  return (
    <footer className="relative z-20 border-t border-purple-500/20 bg-indigo-950/50 backdrop-blur-xl mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="text-2xl">🔮</span>
              <span className="text-xl font-heading font-bold bg-gradient-to-r from-amber-200 to-purple-300 bg-clip-text text-transparent">
                Tarot Reader AI
              </span>
            </div>
            <p className="text-purple-200 text-sm leading-relaxed">
              Free AI-powered tarot readings for guidance and insight on life's questions.
            </p>
          </div>

          {/* Tarot Spreads */}
          <div>
            <h3 className="text-amber-200 font-heading font-bold mb-4">Tarot Spreads</h3>
            <ul className="space-y-2">
              {spreads.map((spread) => (
                <li key={spread.slug}>
                  <a
                    href={`/readings/${spread.slug}`}
                    className="text-purple-100 hover:text-amber-300 transition-colors text-sm"
                  >
                    {spread.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="text-amber-200 font-heading font-bold mb-4">Resources</h3>
            <ul className="space-y-2">
              <li>
                <a href="/cards" className="text-purple-100 hover:text-amber-300 transition-colors text-sm">
                  Tarot Cards Guide
                </a>
              </li>
              <li>
                <a href="https://blog.tarot-reader.ai/" className="text-purple-100 hover:text-amber-300 transition-colors text-sm">
                  Blog
                </a>
              </li>
              <li>
                <a href="/about" className="text-purple-100 hover:text-amber-300 transition-colors text-sm">
                  About Us
                </a>
              </li>
              <li>
                <a href="/how-it-works" className="text-purple-100 hover:text-amber-300 transition-colors text-sm">
                  How It Works
                </a>
              </li>
              <li>
                <a href="/faq" className="text-purple-100 hover:text-amber-300 transition-colors text-sm">
                  FAQ
                </a>
              </li>
              <li>
                <a href="/contact" className="text-purple-100 hover:text-amber-300 transition-colors text-sm">
                  Contact
                </a>
              </li>
              <li>
                <a href="/chat" className="text-purple-100 hover:text-amber-300 transition-colors text-sm">
                  Chat with AI
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-amber-200 font-heading font-bold mb-4">Legal</h3>
            <ul className="space-y-2">
              <li>
                <a href="/privacy" className="text-purple-100 hover:text-amber-300 transition-colors text-sm">
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="/terms" className="text-purple-100 hover:text-amber-300 transition-colors text-sm">
                  Terms of Service
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-purple-500/20 mt-8 pt-8 text-center">
          <p className="text-purple-200 text-sm">
            © {currentYear} Tarot Reader AI. All rights reserved. <span className="text-amber-300">✨</span>
          </p>
          <p className="text-purple-300 text-xs mt-2">
            For entertainment purposes only. Tarot readings are not a substitute for professional advice.
          </p>
        </div>
      </div>
    </footer>
  );
}
